module.exports = __webpack_public_path__ + "img/gift5.6da22f28.png";